package ui.campaign.detailv2.editor.wrapper

import common.frontend.api.Io
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.plus
import org.ssoft.common.tools.EMPTY
import org.ssoft.common.tools.nowDate
import ssoft.frontend.generated.resources.*
import tools.EFieldColorAsLong
import tools.EFieldRegularBoolean
import tools.EFieldRegularDateTime
import tools.await

class CampaignWrapperEMiniApp(
    val data: Io.Campaign
) : ImplCampaignWrapperE {

    init {
        if (data.miniApp.isEmpty()) {
            data.miniApp.add(Io.Campaign.MiniApp())
        }
        val item = data.miniApp.first()
        if (item.dt == LocalDateTime.EMPTY) {
            val defaultDate = kotlin.time.Clock.nowDate().plus(1, kotlinx.datetime.DateTimeUnit.MONTH)
            item.dt = LocalDateTime(defaultDate, kotlinx.datetime.LocalTime(0, 0))
        }
    }

    private val item = data.miniApp.first()

    val labels get() = item.labels

    val enabled = EFieldRegularBoolean(property = item::enabled)
    val datetime = EFieldRegularDateTime(property = item::dt)
    val cardSurfaceColor = EFieldColorAsLong(property = item::bg)
    val cardOnSurfaceColor = EFieldColorAsLong(property = item::fg)

    override val err: Boolean
        get() = enabled.state && (cardSurfaceColor.err || cardOnSurfaceColor.err)

    override suspend fun extractErr(): String? = null


    suspend fun setupLabels() {
        item.labels.days = Res.string.layer_top_detail_editor__miniapp_days.await()
        item.labels.hours = Res.string.layer_top_detail_editor__miniapp_hours.await()
        item.labels.minutes = Res.string.layer_top_detail_editor__miniapp_minutes.await()
        item.labels.seconds = Res.string.layer_top_detail_editor__miniapp_seconds.await()
        item.labels.ended = Res.string.layer_top_detail_editor__miniapp_ended.await()

    }

}
